module.exports = __webpack_public_path__ + "artbox-logo-square@2x.be1ec58b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/artbox-logo-square@2x.png
 ** module id = 210
 ** module chunks = 0
 **/